import { toReset } from 'react-async-client';

import {
    SET_PROJECT_LIST_FILTERS,
    SET_WORKSHEET_LIST_FILTERS,
    SET_PROJECT_MASS_LIST_FILTERS,
    SET_WORKSHEET_MASS_LIST_FILTERS,

    GET_REQUEST_LIST,
    GET_APPROVAL_PROJECT_LIST,
    GET_APPROVAL_PERSON_LIST,
    GET_PROJECT_LIST,
    GET_WORKSHEET_LIST,
    GET_PROJECT_MASS_LIST,
    GET_WORKSHEET_MASS_LIST
} from 'constants/actionTypes';

import {
    defaultApprovalListFilters,
    defaultProjectListFilters,
    defaultWorksheetListFilters,
    defaultProjectMassListFilters,
    defaultNotDoneListFilters,
} from 'constants/defaultFilters';

const createFilterReducer = (GET_DATA, defaultFilters, SET_FILTERS) =>
    (state = defaultFilters, action) => {
        switch(action.type) {
            case SET_FILTERS:
                return action.payload || defaultFilters;
            case toReset(GET_DATA):
                return defaultFilters;
            default:
                return state;
        }
    };

export const requestListFiltersReducer = createFilterReducer(
    GET_REQUEST_LIST,
    defaultApprovalListFilters
);

export const approvalPersonListFiltersReducer = createFilterReducer(
    GET_APPROVAL_PERSON_LIST,
    defaultApprovalListFilters
);

export const approvalProjectListFiltersReducer = createFilterReducer(
    GET_APPROVAL_PROJECT_LIST,
    defaultApprovalListFilters
);

export const projectListFiltersReducer = createFilterReducer(
    GET_PROJECT_LIST,
    defaultProjectListFilters,
    SET_PROJECT_LIST_FILTERS
);

export const worksheetListFiltersReducer = createFilterReducer(
    GET_WORKSHEET_LIST,
    defaultWorksheetListFilters,
    SET_WORKSHEET_LIST_FILTERS
);

export const projectMassListFiltersReducer = createFilterReducer(
    GET_PROJECT_MASS_LIST,
    defaultProjectMassListFilters,
    SET_PROJECT_MASS_LIST_FILTERS
);

export const worksheetMassListFiltersReducer = createFilterReducer(
    GET_WORKSHEET_MASS_LIST,
    {},
    SET_WORKSHEET_MASS_LIST_FILTERS
);

export const notdoneListFiltersReducer = () => defaultNotDoneListFilters;
